import RecipeBook from '@/screens/recipes'
import ArchivedRecipes from '@/screens/recipes/ArchivedRecipes'
import ArchivedCombos from '@/screens/combo/ArchivedCombos'
import auth from './middleware/auth'

import store from '@/store'
const RecipesList = () => import(/* webpackChunkName: "recipes" */ '@/screens/recipes/List')
const BulkEditRecipes = () => import(/* webpackChunkName: "recipes" */ '@/screens/recipes/BulkEdit')
const BulkEditSubrecipes = () => import(/* webpackChunkName: "recipes" */ '@/screens/subrecipes/BulkEdit')
const SubecipesList = () => import(/* webpackChunkName: "recipes" */ '@/screens/subrecipes/List')
const ComboList = () => import(/* webpackChunkName: "recipes" */ '@/screens/combo/List')
const MenuByArea = () => import(/* webpackChunkName: "recipes" */ '@/screens/menu/ListByArea')

const routes = [
  {
    path: '/recipes-book',
    name: 'RecipesBook',
    component: {
      ...RecipeBook,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'RecipesBook') {
          const routes = {
            manager: 'Recipes',
            chef: 'Recipes'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'RecipesBook') {
          const routes = {
            manager: 'Recipes',
            chef: 'Recipes'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'recipes',
        name: 'Recipes',
        component: RecipesList,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      },
      {
        path: 'subrecipes',
        name: 'Subrecipes',
        component: SubecipesList,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      },
      {
        name: 'ComboList',
        component: ComboList,
        path: 'combos',
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      },
      {
        name: 'MenuByArea',
        component: MenuByArea,
        path: 'by-area',
        meta: {
          requireAuth: true,
          permissions: ['manager', 'chef'],
          middleware: { auth }
        }
      }
    ]
  },
  {
    path: '/edit-recipes',
    name: 'EditRecipes',
    component: BulkEditRecipes,
    meta: {
      requireAuth: true,
      permissions: ['manager', 'chef'],
      middleware: { auth }
    }
  },
  {
    path: '/edit-subrecipes',
    name: 'EditSubrecipes',
    component: BulkEditSubrecipes,
    meta: {
      requireAuth: true,
      permissions: ['manager', 'chef'],
      middleware: { auth }
    }
  },
  {
    path: '/archived-recipes',
    name: 'ArchivedRecipes',
    component: ArchivedRecipes,
    meta: {
      requireAuth: true,
      permissions: ['manager', 'chef'],
      middleware: { auth }
    }
  },
  {
    path: '/archived-combos',
    name: 'ArchivedCombos',
    component: ArchivedCombos,
    meta: {
      requireAuth: true,
      permissions: ['manager', 'chef'],
      middleware: { auth }
    }
  }
]

export default routes
